import { render } from "./CreditorsScreen.vue?vue&type=template&id=4684d7ff&scoped=true"
import script from "./CreditorsScreen.vue?vue&type=script&lang=js"
export * from "./CreditorsScreen.vue?vue&type=script&lang=js"

import "./CreditorsScreen.vue?vue&type=style&index=0&id=4684d7ff&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4684d7ff"]])

export default __exports__